import { render } from "./fast-forward.vue?vue&type=template&id=513da4c4"
const script = {}
script.render = render

export default script